// AuthShell — premium dark navy backdrop for all auth pages (Login, Register, Logout).
// Visual language: #0D1B2A bg, glass-morphism card with #34C97B accent border,
// "HOSTRO" wordmark + "Where You Belong" tagline.
import { Link } from "react-router-dom";

export default function AuthShell({ children, footer }) {
  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4 py-10 relative overflow-hidden"
      style={{
        background:
          "radial-gradient(1200px 700px at 15% -10%, rgba(52,201,123,0.18), transparent 60%), radial-gradient(900px 600px at 110% 110%, rgba(52,201,123,0.10), transparent 65%), #0D1B2A",
        fontFamily: "Inter, ui-sans-serif, system-ui",
      }}
      data-testid="auth-shell"
    >
      {/* subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.6) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative w-full max-w-md">
        {/* Brand block */}
        <div className="text-center mb-6">
          <Link to="/" className="inline-flex items-center justify-center gap-2 group" data-testid="auth-brand-link">
            <svg width="44" height="44" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <rect x="2" y="2" width="44" height="44" rx="11" fill="#34C97B" />
              <path d="M11 24 L24 12 L37 24 L37 36 Q37 38 35 38 L13 38 Q11 38 11 36 Z" fill="#FFFFFF" />
              <rect x="20" y="26" width="8" height="12" rx="1.5" fill="#34C97B" />
            </svg>
            <span
              className="text-3xl font-black tracking-tight text-white group-hover:text-[#34C97B] transition"
              style={{ letterSpacing: "-0.02em" }}
            >
              HOSTRO
            </span>
          </Link>
          <p className="text-sm text-white/60 mt-2 tracking-wide">Where You Belong</p>
        </div>

        {/* Glass card */}
        <div
          className="rounded-2xl p-6 md:p-8 shadow-[0_20px_60px_rgba(0,0,0,0.35)]"
          style={{
            background: "rgba(255,255,255,0.05)",
            backdropFilter: "blur(18px)",
            WebkitBackdropFilter: "blur(18px)",
            border: "1px solid rgba(52,201,123,0.35)",
          }}
        >
          {children}
        </div>

        {footer && <div className="mt-5 text-center text-sm text-white/60">{footer}</div>}

        <div className="mt-6 text-center text-xs text-white/40">
          © {new Date().getFullYear()} Hostro Ventures Pvt Ltd · One Platform. Endless Possibilities.
        </div>
      </div>
    </div>
  );
}
